import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import AbstractForm from '../forms/AbstractForm'
import {
  ProfileInfoDataValidationMessage,
  ProfileInfoFormContainer,
} from './styles'

const ProfileInfo = ({ defaultValues = {}, updateProfileInfo }) => {
  const { t } = useTranslation()

  const inputs = [
    {
      label: t('profile.firstName'),
      name: 'firstName',
      width: 4,
    },
    {
      label: t('profile.lastName'),
      name: 'lastName',
      width: 4,
    },
    {
      label: t('profile.email'),
      name: 'email',
      width: 4,
    },
    {
      label: t('profile.phoneNumber'),
      name: 'phoneNumber',
      width: 4,
    },
    {
      label: t('profile.age'),
      name: 'age',
      type: 'number',
      width: 4,
    },
    {
      label: t('profile.gender'),
      name: 'gender',
      renderType: 'select',
      options: [
        {
          value: 'male',
          label: t('profile.male'),
        },
        {
          value: 'female',
          label: t('profile.female'),
        },
      ],
      width: 4,
    },
    {
      label: t('profile.title'),
      name: 'title',
      width: 4,
    },
    {
      label: t('profile.experienceInYears'),
      name: 'experienceInYears',
      type: 'number',
      width: 4,
    },
    {
      label: t('profile.address'),
      name: 'address',
      width: 4,
    },
    {
      label: t('profile.links'),
      name: 'links',
      renderType: 'input-tags',
      width: 4,
    },
    {
      label: t('profile.skills'),
      name: 'skills',
      renderType: 'input-tags',
      width: 4,
    },
    {
      label: t('profile.softSkills'),
      name: 'softSkills',
      renderType: 'input-tags',
      width: 4,
    },
  ]

  const actions = [
    {
      field: 'submit',
      text: 'Next',
      onClick: (data, setIsLoading) => {
        setIsLoading(false)
        updateProfileInfo(data)
      },
    },
  ]

  const defaults = useMemo(() => {
    return {
      firstName: defaultValues.firstName,
      lastName: defaultValues.lastName,
      email: defaultValues.email,
      phoneNumber: defaultValues.phoneNumber,
      age: defaultValues.age,
      gender: defaultValues.gender,
      title: defaultValues.title,
      experienceInYears: defaultValues.experienceInYears,
      address: defaultValues.address,
      links: defaultValues.links,
      skills: defaultValues.skills,
      softSkills: defaultValues.softSkills,
    }
  }, [defaultValues])

  return (
    <>
      <ProfileInfoDataValidationMessage>
        {t('profile.dataValidationMessage')}
      </ProfileInfoDataValidationMessage>
      <ProfileInfoFormContainer>
        <AbstractForm
          inputs={inputs}
          defaultValues={defaults}
          actions={actions}
        />
      </ProfileInfoFormContainer>
    </>
  )
}

ProfileInfo.propTypes = {
  defaultValues: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    age: PropTypes.number,
    gender: PropTypes.string,
    title: PropTypes.string,
    experienceInYears: PropTypes.number,
    address: PropTypes.string,
    links: PropTypes.string,
    skills: PropTypes.string,
    softSkills: PropTypes.string,
  }),
  updateProfileInfo: PropTypes.func.isRequired,
}

export default ProfileInfo
